module.exports = __webpack_public_path__ + "static/media/11.69422e81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/11.jpg
// module id = 79
// module chunks = 0